import { combineReducers } from 'redux';

import filters from './filters';
import period from './period';
import refreshTime from './refreshTime';

/**
 * @typedef {{
 *  filters: import('./filters').StatisticsFiltersReducer,
 *  period: import('./period').StatisticPeriodReducer,
 *  refreshTime: string,
 * }} StatisticsUICommonReducer
 */

export default combineReducers({
  period,
  filters,
  refreshTime,
});
